<div class="flex items-center bg-gray-200 text-gray-700 rounded-md px-3 py-1"
  [ngStyle]="{'background-color': tag.color, 'color': textColor}" [ngClass]="{'opacity-50 duration-50': tag.loading}">
  <span class="inline-flex font-normal" [ngStyle]="{'color': textColor}">{{ tag.value }}</span>
  <button class="bg-transparent border-0 text-2xl leading-none font-semibold outline-none focus:outline-none mb-1 ml-2"
    (click)="remove.emit()">
    &times;
  </button>
</div>
